import React from 'react';
import { Box, Card, CardContent, Grid, Paper, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ProcurementContainer from '../../procurement/containers/ProcurementContainer';

const reportItems = [
  {
    text: 'Cost To Completion',
    path: '/bom/reports/cost-to-completion',
    icon: <AssessmentIcon sx={{ fontSize: 36 }} />,
  },
  {
    text: 'BackOrderTracking',
    path: '/bom/reports/back-order-tracking',
    icon: <LocalShippingIcon sx={{ fontSize: 36 }} />,
  },
];

const ReportsPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Stack spacing={3}>
        <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a' }}>
            Reports
          </Typography>
          <Typography variant="body1" sx={{ color: '#475569', mt: 1 }}>
            Choose a reporting view to explore procurement and delivery performance.
          </Typography>
        </Paper>

        <Grid container spacing={2}>
          {reportItems.map((item) => (
            <Grid item xs={12} md={6} key={item.text}>
              <Card
                component={Link}
                to={item.path}
                sx={{
                  height: '100%',
                  textDecoration: 'none',
                  color: 'inherit',
                  borderRadius: 3,
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ color: '#2563eb' }}>{item.icon}</Box>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      {item.text}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </ProcurementContainer>
  );
};

export default ReportsPage;
